$('[data-fancybox]').fancybox({
  infobar: false,
  buttons: [
    "close"
  ],
  loop: true,
});
